import React from 'react';
import {
  ArrowPathIcon
} from '@heroicons/react/24/outline';

const AgentCard = ({ agent, onEdit, onDelete }) => {
  const hasWorkflow = agent.workflow || agent.workflow_id;

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <div className="mb-3">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">{agent.name}</h3>
          {hasWorkflow && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
              <ArrowPathIcon className="w-3 h-3 mr-1" />
              Workflow
            </span>
          )}
        </div>
        <p className="text-sm text-gray-600">{agent.description}</p>
      </div>
      
      {agent.capabilities && agent.capabilities.length > 0 && (
        <div className="mb-3">
          <div className="flex flex-wrap gap-1">
            {agent.capabilities.map((capability, index) => (
              <span
                key={index}
                className="rounded-full bg-indigo-100 px-2 py-1 text-xs text-indigo-700"
              >
                {capability}
              </span>
            ))}
          </div>
        </div>
      )}
      
      <div className="flex gap-2">
        <button
          onClick={() => onEdit(agent)}
          className="flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Edit
        </button>
        <button
          onClick={() => onDelete(agent.id)}
          className="rounded-md border border-red-300 px-3 py-2 text-sm font-medium text-red-700 hover:bg-red-50"
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default AgentCard;
